// src/components/Dashboard/LoadDetailsCard.js
import { Box, Typography, Card, Grid } from '@mui/material';
import CountUp from 'react-countup';
import { LocalShipping, Storage, Inventory } from '@mui/icons-material'; // Iconlar

function LoadDetailsCard({ kg, m3, kap }) {
  return (
    <Grid container spacing={3}>
      {/* KG Card */}
      <Grid item xs={12} sm={4}>
        <Card
          sx={{
            boxShadow: '0 4px 20px rgba(0, 123, 255, 0.3)',
            borderRadius: '12px',
            p: 2
          }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <LocalShipping sx={{ fontSize: 40, color: '#007BFF' }} />{' '}
            {/* KG için uygun ikon */}
            <Box sx={{ ml: 2 }}>
              <Typography variant="button">KG</Typography>
              <Typography variant="h4">
                <CountUp end={kg} duration={2} />
              </Typography>
            </Box>
          </Box>
        </Card>
      </Grid>

      {/* M³ Card */}
      <Grid item xs={12} sm={4}>
        <Card
          sx={{
            boxShadow: '0 4px 20px rgba(255, 165, 0, 0.3)',
            borderRadius: '12px',
            p: 2
          }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Storage sx={{ fontSize: 40, color: '#FFA500' }} />{' '}
            {/* M³ için uygun ikon */}
            <Box sx={{ ml: 2 }}>
              <Typography variant="button">M³</Typography>
              <Typography variant="h4">
                <CountUp end={m3} duration={2} decimals={2} />
              </Typography>
            </Box>
          </Box>
        </Card>
      </Grid>

      {/* Kap Sayısı Card */}
      <Grid item xs={12} sm={4}>
        <Card
          sx={{
            boxShadow: '0 4px 20px rgba(0, 255, 0, 0.3)',
            borderRadius: '12px',
            p: 2
          }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Inventory sx={{ fontSize: 40, color: '#00FF00' }} />{' '}
            {/* Kap Sayısı için uygun ikon */}
            <Box sx={{ ml: 2 }}>
              <Typography variant="button">Kap Sayısı</Typography>
              <Typography variant="h4">
                <CountUp end={kap} duration={2} />
              </Typography>
            </Box>
          </Box>
        </Card>
      </Grid>
    </Grid>
  );
}

export default LoadDetailsCard;
